module.exports = __webpack_public_path__ + "static/KMN_Desktop_Hover-eb9bca855865f7ca9da76205c3255861.png";